export const INDUSTRIES = [
  {
    label: 'Agriculture/Forestry/Fishing',
    value: 'Agriculture/Forestry/Fishing',
  },
  {
    label: 'Art/Design/Media',
    value: 'Art/Design/Media',
  },
  {
    label: 'Banking/Finance/Real Estate',
    value: 'Banking/Finance/Real Estate',
  },
  {
    label: 'Business/Sales/Office',
    value: 'Business/Sales/Office',
  },
  {
    label: 'Construction/Energy/Mining',
    value: 'Construction/Energy/Mining',
  },
  {
    label: 'Education/Library',
    value: 'Education/Library',
  },
  {
    label: 'Engineer/Architect/Science/Math',
    value: 'Engineer/Architect/Science/Math',
  },
  {
    label: 'Food Service/Hotel Services',
    value: 'Food Service/Hotel Services',
  },
  {
    label: 'Government/Military',
    value: 'Government/Military',
  },
  {
    label: 'Homemaker(full-time)',
    value: 'Homemaker(full-time)',
  },
  {
    label: 'Information Technology',
    value: 'Information Technology',
  },
  {
    label: 'Insurance',
    value: 'Insurance',
  },
  {
    label: 'Legal/Law Enforcement/Security',
    value: 'Legal/Law Enforcement/Security',
  },
  {
    label: 'Medical/Social Services/Religion',
    value: 'Medical/Social Services/Religion',
  },
  {
    label: 'Personal Care/Service',
    value: 'Personal Care/Service',
  },
  {
    label: 'Production/Manufacturing',
    value: 'Production/Manufacturing',
  },
  {
    label: 'Repair/Maintenance/Grounds',
    value: 'Repair/Maintenance/Grounds',
  },
  {
    label: 'Retired(full-time)',
    value: 'Retired(full-time)',
  },
  {
    label: 'Sports/Recreation',
    value: 'Sports/Recreation',
  },
  {
    label: 'Student(full-time)',
    value: 'Student(full-time)',
  },
  {
    label: 'Travel/Transportation/Storage',
    value: 'Travel/Transportation/Storage',
  },
  {
    label: 'Unemployed',
    value: 'Unemployed',
  },
];
